'use strict';

exports.__esModule = true;
exports.default = {
  LIGHT: 'light',
  DARK: 'dark'
};


//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-facebook/lib/constants/ColorScheme.js
// module id = 226
// module chunks = 0